class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    this.removeHeaderCartIconListeners();
    this.cartLink = cartLink;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    this.onCartClick = (event) => {
      event.preventDefault();
      this.open(cartLink);
    };
    this.onCartKeyDown = (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    };
    cartLink.addEventListener('click', this.onCartClick);
    cartLink.addEventListener('keydown', this.onCartKeyDown);
  }

  removeHeaderCartIconListeners() {
    this.cartLink?.removeEventListener('click', this.onCartClick);
    this.cartLink?.removeEventListener('keydown', this.onCartKeyDown);
    this.cartLink = null;
  }

  connectedCallback() {
    this.setHeaderCartIconAccessibility();
  }

  open(triggeredBy) {
    if (!this.isConnected) return;
    clearTimeout(this.openTimer);
    clearTimeout(this.closeTimer);
    clearTimeout(this.focusTimer);
    cancelAnimationFrame(this.focusFrame);
    if (triggeredBy) this.setActiveElement(triggeredBy);
    DrawerInteractionLock.acquire(this);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    this.openTimer = setTimeout(() => {
      this.classList.add('animate', 'active');
      const focusDrawer = () => {
        if (this.classList.contains('active') && DrawerInteractionLock.isTop(this) && !this.contains(document.activeElement)) {
          DrawerInteractionLock.focusTop();
        }
      };
      this.focusFrame = requestAnimationFrame(() => {
        this.focusFrame = requestAnimationFrame(focusDrawer);
      });
      this.focusTimer = setTimeout(focusDrawer, 400);
    });
  }

  close() {
    clearTimeout(this.openTimer);
    clearTimeout(this.focusTimer);
    cancelAnimationFrame(this.focusFrame);
    clearTimeout(this.closeTimer);
    this.classList.remove('active');
    this.closeTimer = setTimeout(() => DrawerInteractionLock.release(this, this.activeElement), 400);
  }

  disconnectedCallback() {
    clearTimeout(this.openTimer);
    clearTimeout(this.focusTimer);
    cancelAnimationFrame(this.focusFrame);
    clearTimeout(this.closeTimer);
    this.removeHeaderCartIconListeners();
    DrawerInteractionLock.release(this);
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (!this.isConnected) return;
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
